export default __webpack_public_path__ + "images/1e1a44834db462f04793444ac8ba3f2b-walking.webp";